import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody } from 'reactstrap';

import Icon from '../../../common/Icon';
const AddressCard = ({ address, isCompany, headerSlot, footerSlot }) => {
  const hasAddressData =
    address.company ||
    address.firstName ||
    address.lastName ||
    address.streetAddress ||
    address.postalCode ||
    address.city ||
    address.country ||
    address.phone ||
    address.email ||
    address.vatNumber;

  if (!hasAddressData && !headerSlot && !footerSlot) {
    return null;
  }

  const companyTrimmed = (address.company || '').trim();

  const displayName = !isCompany
    ? `${address.firstName || ''} ${address.lastName || ''}`.trim() ||
      address.company ||
      ''
    : '';

  const showCompanyLine =
    !isCompany &&
    Boolean(companyTrimmed) &&
    companyTrimmed !== (displayName || '').trim();

  const contactPerson =
    isCompany && (address.firstName || address.lastName)
      ? `${address.firstName || ''} ${address.lastName || ''}`.trim()
      : null;

  const vatTrimmed = (address.vatNumber || '').trim();

  const nameLineShowsCompany =
    !isCompany &&
    Boolean(companyTrimmed) &&
    (displayName || '').trim() === companyTrimmed;

  const showVatWithCompanyLine = Boolean(vatTrimmed && showCompanyLine);

  const showStandaloneVat = Boolean(
    vatTrimmed &&
      (isCompany ? !companyTrimmed : !nameLineShowsCompany && !showCompanyLine)
  );

  return (
    <div className="AddressCard">
      <Card className="AddressCard__card">
        <CardBody className="AddressCard__body">
          {headerSlot ? (
            <div className="AddressCard__header-slot">{headerSlot}</div>
          ) : null}
          <div className="AddressCard__content">
            {isCompany ? (
              <>
                {companyTrimmed ? (
                  <div className="AddressCard__name AddressCard__name--company-primary">
                    {companyTrimmed}
                    {vatTrimmed ? (
                      <span className="AddressCard__vat-suffix">
                        {' '}
                        ({vatTrimmed})
                      </span>
                    ) : null}
                  </div>
                ) : null}
                {contactPerson ? (
                  <div className="AddressCard__contact-person">
                    {contactPerson}
                  </div>
                ) : null}
              </>
            ) : (
              <>
                {displayName ? (
                  <div className="AddressCard__name">
                    {displayName}
                    {vatTrimmed && nameLineShowsCompany ? (
                      <span className="AddressCard__vat-suffix">
                        {' '}
                        ({vatTrimmed})
                      </span>
                    ) : null}
                  </div>
                ) : null}

                {showCompanyLine ? (
                  <div className="AddressCard__company">
                    {address.company}
                    {showVatWithCompanyLine ? (
                      <span className="AddressCard__vat-suffix">
                        {' '}
                        ({vatTrimmed})
                      </span>
                    ) : null}
                  </div>
                ) : null}
              </>
            )}

            {showStandaloneVat ? (
              <div className="AddressCard__vat">({vatTrimmed})</div>
            ) : null}

            {address.streetAddress && (
              <div className="AddressCard__street">{address.streetAddress}</div>
            )}

            {(address.postalCode || address.city) && (
              <div className="AddressCard__postal-city">
                {address.postalCode && address.city
                  ? `${address.postalCode} ${address.city}`
                  : address.postalCode || address.city}
              </div>
            )}

            {address.country && (
              <div className="AddressCard__country">{address.country}</div>
            )}

            {address.phone && (
              <div className="AddressCard__phone">
                <Icon name="phone" className="AddressCard__phone-icon" />
                {address.phone}
              </div>
            )}

            {address.email && (
              <div className="AddressCard__email">
                <Icon name="envelope" className="AddressCard__email-icon" />
                {address.email}
              </div>
            )}
          </div>
          {footerSlot ? (
            <div className="AddressCard__footer-slot">{footerSlot}</div>
          ) : null}
        </CardBody>
      </Card>
    </div>
  );
};

AddressCard.propTypes = {
  headerSlot: PropTypes.node,
  footerSlot: PropTypes.node,
  address: PropTypes.shape({
    company: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    streetAddress: PropTypes.string,
    postalCode: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    vatNumber: PropTypes.string,
  }).isRequired,
  isCompany: PropTypes.bool,
};

AddressCard.defaultProps = {
  isCompany: false,
  headerSlot: null,
  footerSlot: null,
};

export default AddressCard;
